import { ConfirmationModal, ModalType } from '@access-erp/ui-components';
import { useEffect, useState } from 'react';

import { useGetGridContractLines } from '@/pages/ContractLines/hooks/useGetGridContractLines';
import useDeletePurchaseOrder from '../../hooks/useDeletePurchaseOrder';
import { PurchaseOrderWithId } from '@/utils/data-helpers/types';
import { useLoadingAnimation } from '@/components/LoadingAnimation/useLoadingAnimation.hook';
import { FormattingUtils } from '@/utils/Formatting.utils';

interface DeletePurchaseOrdersModalProps {
  isVisible: boolean;
  onClose: () => void;
  refreshGrid: () => void;
  purchaseOrder: PurchaseOrderWithId;
}

export function DeletePurchaseOrdersModal({
  isVisible,
  onClose,
  refreshGrid,
  purchaseOrder,
}: DeletePurchaseOrdersModalProps) {
  const { getGridContractLines } = useGetGridContractLines();
  const [contractLinesCount, setContractLinesCount] = useState(0);
  const [contractsCount, setContractsCount] = useState(0);
  const { toggleLoadingAnimation } = useLoadingAnimation();
  const [loading, setLoading] = useState(false);
  const { deletePurchaseOrder } = useDeletePurchaseOrder();

  const handleConfirm = () => {
    deletePurchaseOrder([purchaseOrder.id], refreshGrid);
    onClose();
  };

  useEffect(() => {
    const fetchContractLines = async () => {
      setLoading(true);
      const contractLines = await getGridContractLines({
        filter: {
          poNumber: { eq: purchaseOrder.poNumber },
        },
      });
      setContractLinesCount(contractLines?.items?.length ?? 0);
      setContractsCount(Array.from(new Set(contractLines?.items?.map((cl) => cl?.contractId))).length);
      setLoading(false);
    };
    fetchContractLines();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchaseOrder]);

  useEffect(() => {
    toggleLoadingAnimation(loading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return (
        <>
            {!loading && (
                <ConfirmationModal
                    width="small"
                    open={isVisible}
                    title="Delete Purchase Order"
                    type={ModalType.Warning}
                    confirmButtonText="Confirm"
                    cancelButtonText="Cancel"
                    onClose={onClose}
                    onConfirm={handleConfirm}
                >
                    {' '}
                    {contractLinesCount > 0 ? (
                        <>
                            This purchase order is assigned to {contractLinesCount}{' '}
                            {FormattingUtils.pluralize(contractLinesCount, 'contract line')} on {contractsCount}{' '}
                            {FormattingUtils.pluralize(contractsCount, 'contract')}!
                            <br />
                        </>
                    ) : null}
                    Are you sure you wish to continue?
                </ConfirmationModal>
            )}
        </>
  );
}
